import script from "./Subcontractor-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Subcontractor-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Subcontractor-Questionnaire-Main.vue?vue&type=style&index=0&id=f3b54108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b54108"]])

export default __exports__